// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorScreen_error__c_ydt"};